module.exports = __webpack_public_path__ + "img/individu_accident.064f936c.jpeg";